import { paddingBottom } from '@/features/pos/components/ProductCatalog/parts/CategoriesWithProducts/constants'
import { StyleSheet } from 'react-native'
import { createStyleSheet } from 'react-native-unistyles'

export const listStylesheet = createStyleSheet((_, { insets }) => ({
    contentContainer: {
        variants: {
            layout: {
                compact: {
                    paddingBottom: insets.bottom + paddingBottom,
                },
                extended: {
                    paddingBottom: insets.bottom + paddingBottom,
                },
            },
        },
    },
}))

export const productStyles = StyleSheet.create({
    product: {
        flex: 1,
    },
})
